import snakecaseKeys from 'snakecase-keys'
import type { FlowAccumulator } from '../model'

export const transformBody =
  <TBody>(body?: TBody) =>
  (acc: FlowAccumulator) => {
    const { disableAutoSnakeCase, sendRawBody, bodyTransformer } = acc.reqConfig!

    if (body) {
      if (bodyTransformer) {
        acc.bodyTransformed = bodyTransformer(body)
        return acc
      }

      if (sendRawBody) {
        acc.bodyTransformed = body as BodyInit
        return acc
      }

      if (disableAutoSnakeCase) {
        acc.bodyTransformed = JSON.stringify(body)
        return acc
      }

      const bodySnakeCased = snakecaseKeys(body, {
        deep: true,
        exclude: ['refreshToken'],
      })

      acc.bodyTransformed = JSON.stringify(bodySnakeCased)
    }

    return acc
  }
